import { NavLink, useParams } from "react-router-dom";

import Divider from "../../components/Divider";
import Icon from "../../components/Icon";
import LiveChatTab from "../../components/LiveChatTab";
import React from "react";
import addComment from "../../helpers/addComment";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import useComments from "../../hooks/useComments";
import useCurrentUser from "../../hooks/useCurrentUser";
import useEvent from "../../hooks/useEvent";
import usePosters from "../../hooks/usePosters";

const Poster = () => {
  const { posterID } = useParams<{
    posterID: string;
  }>();
  const event = useEvent();
  const { posters } = usePosters();
  const currentUser = useCurrentUser();
  const poster = posters.find((poster) => poster.code === posterID) || {};
  const { code, image, author } = poster;

  // Get comments
  const comments = useComments(`${event}-posters`, code);

  // Add new comment
  const handleNewMessage = (comment: string) => {
    if (currentUser) {
      const userID = currentUser.ID;
      addComment(userID, comment, `${event}-posters`, code);
    }
  };

  return (
    <div className="PosterPage">
      <div className="w-full h-full">
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="flex flex-wrap w-full h-full">
            <div className="w-full lg:w-4/12">
              <div className="relative w-full h-full bg-gray-100">
                <div className="absolute top-0 right-0 z-20 p-4">
                  <NavLink to={`/${event}/posters`}>
                    <Icon icon={faTimes} />
                  </NavLink>
                </div>

                <div className="absolute top-0 left-0 z-10 w-full p-4">
                  <div className="space-y-2">
                    <h1 className="text-5xl">{code}</h1>
                    {author ? (
                      <div className="text-sm text-gray-400">{author}</div>
                    ) : null}
                  </div>
                </div>

                <div
                  className="absolute left-0 w-full p-4"
                  style={{
                    top: "10vh",
                    bottom: "30px",
                  }}
                >
                  <Divider />
                  <LiveChatTab
                    comments={comments}
                    onNewMessage={handleNewMessage}
                  />
                </div>
              </div>
            </div>
            <div className="w-full lg:w-8/12">
              <div className="flex items-center justify-center h-full bg-black">
                {image ? (
                  <iframe title={code} src={image} width="100%" height="100%" />
                ) : (
                  <div className="max-w-md px-6 text-center text-gray-300">
                    <h2 className="text-xl text-white">Poster unavailable</h2>
                    <p className="mt-3 text-sm text-gray-400">
                      This poster is part of an archived demo of the
                      SEAADE-IADR-SEA 2020 conference. The original file is no
                      longer hosted, so it cannot be displayed.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Poster;
